import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, DeferLoadingStrategy, I18nModule, UrlModule } from '@spartacus/core';
import { DynamicFormsModule } from '../../dynamic-forms/dynamic-forms.module';
import { MyaccountEmployeeAddressModule } from '../myaccount-employee-address/myaccount-employee-address.module';
import { MyaccountPermissionsModule } from '../myaccount-permissions/myaccount-permissions.module';
import { AddEmployeeComponent } from './add-employee.component';

@NgModule({
  declarations: [AddEmployeeComponent],
  imports: [
    CommonModule,
    DynamicFormsModule,
    I18nModule,
    RouterModule,
    UrlModule,
    MyaccountPermissionsModule,
    MyaccountEmployeeAddressModule,
    ConfigModule.withConfig({
      cmsComponents: {
        AddEmployeeComponent: {
          component: AddEmployeeComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
  ],
})
export class AddEmployeeModule {}
